import { SxProps, Theme } from '@mui/material';

import React from 'react';

import { ServiceTitanAdjustableCapacityDTO, TimezoneAbbreviationEnum } from '_lib/api/apiTypes.shim';

import { Stack } from '_lib/components/Stack/Stack';

import { VerticalDivider } from '_lib/styles/PhoneCall.styled';

import { AvailabilityPercentage } from '../AvailabilityPercentage/AvailabilityPercentage';
import { AvailableTime } from '../AvailableTime/AvailableTime';

type CapacityItemDisplayProps = {
  capacityItem: ServiceTitanAdjustableCapacityDTO;
  timezone: TimezoneAbbreviationEnum;
  sx?: SxProps<Theme>;
};

export const CapacityItemDisplay = (props: CapacityItemDisplayProps) => {
  const { capacityItem, timezone, sx } = props;

  return (
    <Stack direction='row' sx={sx}>
      <AvailableTime capacityItem={capacityItem} companyTimeZone={timezone} />
      <VerticalDivider />
      <AvailabilityPercentage capacityItem={capacityItem} />
    </Stack>
  );
};
